// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_rattan_surface/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_rattan_surface: ModuleSchema = {
  "id": "core_rattan_surface",
  "uniqueId": "B3D_RSU01",
  "createdAt": "2026-10-11T07:40:00Z",
  "updatedAt": "2026-10-11T09:57:51.690Z",
  "label": "Rattan Surface",
  "description": "Standalone reusable woven-rattan surface primitive, separate from core_rattan_lattice.",
  "category": "core_geometry",
  "tags": [
    "core",
    "rattan",
    "surface",
    "woven"
  ],
  "sliders": [
    {
      "key": "diameter",
      "label": "Surface Diameter (mm)",
      "min": 40,
      "max": 150,
      "default": 60,
      "step": 2,
      "unit": "mm"
    },
    {
      "key": "height",
      "label": "Surface Height (mm)",
      "min": 10,
      "max": 120,
      "default": 40,
      "step": 2,
      "unit": "mm"
    },
    {
      "key": "strandThickness",
      "label": "Strand Thickness (mm)",
      "min": 0.4,
      "max": 2.5,
      "default": 0.84,
      "step": 0.02,
      "unit": "mm"
    },
    {
      "key": "strandHeight",
      "label": "Strand Height (Z, mm)",
      "min": 1,
      "max": 5,
      "default": 2,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "wavePitch",
      "label": "Wave Pitch (mm)",
      "min": 1.5,
      "max": 8,
      "default": 6,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "waveAmplitude",
      "label": "Wave Amplitude (mm)",
      "min": 0.4,
      "max": 4,
      "default": 1,
      "step": 0.1,
      "unit": "mm"
    },
    {
      "key": "layerOverlap",
      "label": "Layer Overlap (mm)",
      "min": 0,
      "max": 1,
      "default": 0,
      "step": 0.05,
      "unit": "mm"
    },
    {
      "key": "bellyFactor",
      "label": "Belly Bulge",
      "min": 0.8,
      "max": 1.8,
      "default": 1,
      "step": 0.05
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "rattan_surface",
      "label": "Rattan Surface",
      "default": "#D97706",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "rattan_square",
      "label": "Rattan Square",
      "default": "#D97706",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "rattan_pillow",
      "label": "Rattan Pillow",
      "default": "#D97706",
      "targetGroupIds": [
        2
      ]
    },
    {
      "key": "rattan_waves_tier",
      "label": "Rattan Waves Tier",
      "default": "#D97706",
      "targetGroupIds": [
        3
      ]
    }
  ],
  "objects": [
    {
      "id": "rattan_surface_obj",
      "label": "Rattan Surface",
      "name": "Rattan Surface",
      "color": "#D97706",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "rattan_surface",
          "label": "Rattan Surface",
          "name": "Rattan Surface",
          "groupId": 0,
          "colorKey": "rattan_surface",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    },
    {
      "id": "rattan_square_obj",
      "label": "Rattan Square",
      "name": "Rattan Square",
      "color": "#D97706",
      "assembled_z_offset": 0,
      "exploded_z_offset": 50,
      "parts": [
        {
          "id": "rattan_square",
          "label": "Rattan Square",
          "name": "Rattan Square",
          "groupId": 1,
          "colorKey": "rattan_square",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 50,
          "export_stl": true
        }
      ]
    },
    {
      "id": "rattan_pillow_obj",
      "label": "Rattan Pillow",
      "name": "Rattan Pillow",
      "color": "#D97706",
      "assembled_z_offset": 0,
      "exploded_z_offset": 75,
      "parts": [
        {
          "id": "rattan_pillow",
          "label": "Rattan Pillow",
          "name": "Rattan Pillow",
          "groupId": 2,
          "colorKey": "rattan_pillow",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 75,
          "export_stl": true
        }
      ]
    },
    {
      "id": "rattan_waves_tier_obj",
      "label": "Rattan Waves Tier",
      "name": "Rattan Waves Tier",
      "color": "#D97706",
      "assembled_z_offset": 0,
      "exploded_z_offset": 100,
      "parts": [
        {
          "id": "rattan_waves_tier",
          "label": "Rattan Waves Tier",
          "name": "Rattan Waves Tier",
          "groupId": 3,
          "colorKey": "rattan_waves_tier",
          "defaultColor": "#D97706",
          "assembled_z_offset": 0,
          "exploded_z_offset": 100,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "surface",
      "label": "Rattan Surface",
      "targetGroupId": 0,
      "default": true
    },
    {
      "id": "square",
      "label": "Rattan Square",
      "targetGroupId": 1,
      "default": true
    },
    {
      "id": "pillow",
      "label": "Rattan Pillow",
      "targetGroupId": 2,
      "default": true
    },
    {
      "id": "waves_tier",
      "label": "Rattan Waves Tier",
      "targetGroupId": 3,
      "default": true
    }
  ]
};
